import { Component } from '@angular/core';

@Component({ selector: 'app-blank', standalone: true, template: '' })
export class BlankComponent {}
